/** WebSocket с автопереподключением. Подписчики получают события сервера. */
import type { RealtimeEvent } from '@sync-tracker/shared';

type Handler = (e: RealtimeEvent) => void;
type StatusHandler = (connected: boolean) => void;

class Realtime {
  private ws: WebSocket | null = null;
  private handlers = new Set<Handler>();
  private statusHandlers = new Set<StatusHandler>();
  private retry = 0;
  private timer: number | null = null;
  private wanted = false;
  connected = false;

  connect() {
    this.wanted = true;
    if (this.ws) return;
    const proto = location.protocol === 'https:' ? 'wss' : 'ws';
    const ws = new WebSocket(`${proto}://${location.host}/api/ws`);
    this.ws = ws;
    ws.onopen = () => {
      this.retry = 0;
      this.setConnected(true);
    };
    ws.onmessage = (m) => {
      try {
        const e = JSON.parse(m.data as string) as RealtimeEvent;
        for (const h of this.handlers) h(e);
      } catch {
        /* пропускаем битые сообщения */
      }
    };
    ws.onclose = () => {
      this.ws = null;
      this.setConnected(false);
      if (!this.wanted) return;
      const delay = Math.min(15_000, 500 * 2 ** this.retry++);
      this.timer = window.setTimeout(() => this.connect(), delay);
    };
  }

  disconnect() {
    this.wanted = false;
    if (this.timer) window.clearTimeout(this.timer);
    this.ws?.close();
    this.ws = null;
  }

  on(h: Handler) {
    this.handlers.add(h);
    return () => this.handlers.delete(h);
  }

  onStatus(h: StatusHandler) {
    this.statusHandlers.add(h);
    return () => this.statusHandlers.delete(h);
  }

  private setConnected(v: boolean) {
    this.connected = v;
    for (const h of this.statusHandlers) h(v);
  }
}

export const realtime = new Realtime();
